export const INSTRUMENTS = [
  "Violin", "Viola", "Cello", "Double Bass",
  "Flute", "Piccolo", "Oboe", "Cor Anglais", "Clarinet", "Bass Clarinet",
  "Bassoon", "Contrabassoon", "Saxophone",
  "French Horn", "Trumpet", "Trombone", "Bass Trombone", "Tuba",
  "Timpani", "Percussion",
  "Harp", "Piano", "Organ", "Harpsichord",
  "Guitar", "Bass Guitar",
  "Voice (Soprano)", "Voice (Mezzo-Soprano)", "Voice (Alto)",
  "Voice (Tenor)", "Voice (Baritone)", "Voice (Bass)",
  "Conductor", "Other",
];

export const VOICE_TYPES = [
  "", "Soprano", "Mezzo-Soprano", "Alto", "Tenor", "Baritone", "Bass",
];

export const FEE_PREFS = [
  { value: "any", label: "Any (paid / unpaid / expenses)" },
  { value: "paid", label: "Paid only" },
  { value: "expenses", label: "Expenses covered" },
  { value: "unpaid", label: "Happy to play unpaid" },
];

export const EVENT_TYPES = [
  { value: "rehearsal", label: "Rehearsal" },
  { value: "concert", label: "Concert" },
  { value: "sectional", label: "Sectional" },
  { value: "emergency_dep", label: "Emergency dep" },
];
